import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Partners() {
  const partners = [
    {
      name: "글로벌 테크",
      logo: "https://static.readdy.ai/image/4015a3fe38dcf49d1dfca5fec74a66c9/745b82c89b5423a03ca7b9ba84114456.webp",
      description: "혁신적인 기술 솔루션 제공"
    },
    {
      name: "스마트 로지스틱스",
      logo: "https://static.readdy.ai/image/4015a3fe38dcf49d1dfca5fec74a66c9/dcda2a8965ad0acfc5f989a4b3b642c3.png",
      description: "스마트 물류 시스템 전문"
    },
    {
      name: "이커머스 플러스",
      logo: "https://static.readdy.ai/image/4015a3fe38dcf49d1dfca5fec74a66c9/f601dce86bf7f9d912e0f1f83d234e7c.png",
      description: "온라인 쇼핑몰 통합 솔루션"
    },
    {
      name: "퓨처 웨어하우스",
      logo: "https://static.readdy.ai/image/4015a3fe38dcf49d1dfca5fec74a66c9/24d226c243295a6ee340de3f599b1ffc.jpeg",
      description: "미래형 창고 관리 시스템"
    },
    {
      name: "디지털 트레이드",
      logo: "https://static.readdy.ai/image/4015a3fe38dcf49d1dfca5fec74a66c9/0ee55cfd14ac1afb6ae27695fd259800.png",
      description: "글로벌 디지털 무역 플랫폼"
    },
    {
      name: "코리아 익스프레스",
      logo: "https://static.readdy.ai/image/4015a3fe38dcf49d1dfca5fec74a66c9/0e397935268646975d579cafb6a2123b.jpeg",
      description: "국내 최고 속도의 배송 서비스"
    },
    {
      name: "아시아 커넥트",
      logo: "https://static.readdy.ai/image/4015a3fe38dcf49d1dfca5fec74a66c9/9f99427d529f5306f6c7132fd7f838da.jpeg",
      description: "아시아 비즈니스 네트워크"
    },
    {
      name: "클라우드 솔루션즈",
      logo: "https://static.readdy.ai/image/4015a3fe38dcf49d1dfca5fec74a66c9/7dda8002e4b3da7d7e7634fa0b3dd67d.jpeg",
      description: "클라우드 기반 통합 솔루션"
    },
    {
      name: "그린 로지스",
      logo: "https://static.readdy.ai/image/4015a3fe38dcf49d1dfca5fec74a66c9/d62e66f2d45eff4e400a7d348af39819.jpeg",
      description: "친환경 물류 서비스"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-blue-600 to-blue-800">
        <div className="absolute inset-0 bg-black bg-opacity-20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            올딩스 로지스 협력사
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
            올딩스 로지스는<br />
            다양한 분야에 물류친구가 되겠습니다.
          </p>
        </div>
      </section>

      {/* Partner Companies */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              협력사
            </h2>
            <p className="text-xl text-gray-600">
              올딩스 로지스와 함께하는 우수한 파트너들
            </p>
          </div>

          {/* Partners Grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
            {partners.map((partner, index) => (
              <div key={index} className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
                <div className="flex items-center justify-center h-48 mb-4">
                  <img 
                    src={partner.logo} 
                    alt={partner.name}
                    className="max-h-full max-w-full object-contain"
                  />
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* Partnership Process */}
      <section className="py-20 bg-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              파트너십 프로세스
            </h2>
            <p className="text-xl text-gray-600">
              체계적인 협력 과정을 통한 성공적인 파트너십
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              {
                step: '01',
                title: '상담 및 분석',
                description: '비즈니스 요구사항 분석 및 맞춤형 솔루션 제안'
              },
              {
                step: '02',
                title: '계약 체결',
                description: '상호 이익을 보장하는 공정한 계약 조건 협의'
              },
              {
                step: '03',
                title: '시스템 연동',
                description: '효율적인 업무를 위한 시스템 통합 및 연동'
              },
              {
                step: '04',
                title: '운영 및 관리',
                description: '지속적인 모니터링과 개선을 통한 서비스 최적화'
              }
            ].map((process, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-xl font-bold text-white">{process.step}</span>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {process.title}
                </h3>
                <p className="text-gray-600">
                  {process.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
